import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {DialogModule} from 'app/dialog/dialog/dialog.module';
import {CarsErrorHandlingModule} from 'app/error-handling/cars-error-handling.module';
import {FragmentIndexModule} from 'app/fragment/indexing/fragment-index.module';
import {CarsPermissionPipesModule} from 'app/permissions/pipes/cars-permission-pipes.module';
import {RequiredNonWhitespaceModule} from 'app/utils/directives/required-non-whitespace.module';
import {SectionListMenuModule} from '../section-list-menu/section-list-menu.module';
import {SectionListItemComponent} from './section-list-item.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatMenuModule,
    MatProgressBarModule,
    RouterModule,
    CarsErrorHandlingModule,
    RequiredNonWhitespaceModule,
    DialogModule,
    FragmentIndexModule,
    MatListModule,
    SectionListMenuModule,
    CarsPermissionPipesModule,
  ],
  declarations: [SectionListItemComponent],
  exports: [SectionListItemComponent],
})
export class SectionListItemModule {}
